import { FC, SVGProps } from 'react';

export const RadioCheckedIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none" {...props}>
		<rect y="0.5" width="18" height="18" rx="9" fill="currentColor" />
		<rect x="0.5" y="1" width="17" height="17" rx="8.5" stroke="currentColor" />
	</svg>
);
